import { Text } from "@chakra-ui/react";

export interface ErrorComponentProps {
  text: string;
}

const ErrorComponent = ({ text }: ErrorComponentProps) => (
  <Text p={4} bg="tomato" color="white" borderRadius="md">
    {text}
  </Text>
);

export default ErrorComponent;
